




































import { Vue, Component } from 'vue-property-decorator';
import BaseComponent from '@/asdcom/BaseComponent';
import { VcCreateClaimMessageInputDto } from '@/asdcom/apiproxy/apiproxy.dto';
import util from '@/lib/util';

@Component({})
export default class NewMessage extends BaseComponent {
  loading: boolean = false;
  inputModel = new VcCreateClaimMessageInputDto();

  onClose() {
    this.$emit("onClose");
    this.inputModel = new VcCreateClaimMessageInputDto();
  }

  onSave() {
    this.ValidateAll().then((isValid: boolean) => {
      if (isValid) {
        this.loading = true;
        this.inputModel.vcClaimNumber = this.$route.params.claimNumber;
        this.$appsvs.vcpOnlineOkStaff.sendMessageToApplicant(this.inputModel)
          .then((res: any) => {
            this.onClose();
          }).finally(() => {
            this.loading = false;
          })
      }
    })
  }
}
